var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading || !_vm.hasAvatar)?_c('BaseAvatar',{attrs:{"display-name":_vm.displayName,"size":40}}):_c('BaseAvatar',{attrs:{"display-name":_vm.displayName,"url":_vm.avatarUrl,"size":40}})}
var staticRenderFns = []

export { render, staticRenderFns }